<template>
  <WidgetBase :widget="widget">
    <template #timer>
      <div class="text-uppercase q-mr-sm">the code expires in:</div>
      <Timer
        logic="decrease"
        :startSeconds="300"
        :onFinishSeconds="0"
        :stopOnFinish="true"
        @onStop="codeExpired = true"
        ref="timer"
      />
    </template>

    <template #code>
      <div
        class="row items-center justify-center"
        style="min-height: 78px"
        v-if="gettingCode"
      >
        <q-spinner-dots color="white" size="2em" />
      </div>

      <span class="code" v-else-if="!codeExpired">
        {{ code }}
      </span>

      <q-btn
        label="get new code"
        text-color="white"
        class="full-width"
        size="30px"
        flat
        @click="getCode"
        v-else
      />
    </template>
  </WidgetBase>
</template>

<script>
import Timer from "src/components/Timer.vue";
import { internalRedirect } from "src/utils/redirect";
import WidgetBase from "src/components/WidgetBase.vue";

export default {
  name: "Widget",
  data() {
    return {
      code: "",
      showTimer: false,
      codeExpired: false,
      gettingCode: false,
    };
  },
  computed: {
    widget: {
      get() {
        return this.$store.state.app.config.widget;
      },
    },
  },
  async mounted() {
    internalRedirect("/widget", this.$route);
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("meeting/login");
      await this.getCode();
    },
    async getCode() {
      this.gettingCode = true;
      this.code = await this.$meeting.createCode();
      this.showTimer = true;
      this.codeExpired = false;
      this.gettingCode = false;
      this.$nextTick(() => {
        this.$refs.timer?.reset();
        this.$refs.timer.start();
      });
    },
  },
  components: { Timer, WidgetBase },
  watch: {
    codeExpired(val) {
      if (val) {
        this.$meeting.codeExpired(this.code);
      }
    },
  },
};
</script>
